import apiClient from './client';

export interface ServiceStatus {
  name: string;
  status: string;
  latency: string;
  version?: string;
  model?: string;
  dimension?: number;
  base_url?: string;
  api_keys?: Record<string, { configured: boolean; status: string }>;
}

export interface ServerTime {
  current_time: string;
  timezone: string;
}

export interface ServiceStatusResponse {
  services: ServiceStatus[];
  server_time?: ServerTime;
}

export interface SystemOverview {
  users: Record<string, unknown>;
  documents: Record<string, unknown>;
  memories: Record<string, unknown>;
}

export const healthApi = {
  async getServiceStatus(): Promise<ServiceStatusResponse> {
    const response = await apiClient.get<ServiceStatusResponse>('/health/services');
    return response.data;
  },

  async getSystemOverview(): Promise<SystemOverview> {
    const response = await apiClient.get<SystemOverview>('/health/overview');
    return response.data;
  },
};
